import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { FormattedMessage } from 'react-intl';
import { URL_APP_IOS, URL_APP_ANDROID } from 'constants/urls';

var ICON_APP_IOS = require('../../../style-guide/templates/static/assets/images/css/download-appstore.svg');

var ICON_APP_ANDROID = require('../../../style-guide/templates/static/assets/images/css/download-playstore.svg');

export var ANDROID = 'android';
export var IOS = 'ios';
export var AppDownloadIcons =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AppDownloadIcons, _PureComponent);

  function AppDownloadIcons() {
    _classCallCheck(this, AppDownloadIcons);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppDownloadIcons).apply(this, arguments));
  }

  _createClass(AppDownloadIcons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          extraClass = _this$props.extraClass,
          handleClick = _this$props.onClick;
      return React.createElement("ul", {
        className: classNames('app-download-icons', extraClass)
      }, React.createElement("li", null, React.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: URL_APP_IOS,
        onClick: handleClick && handleClick.bind(null, IOS)
      }, React.createElement(Isvg, {
        className: "svg",
        uniquifyIDs: false,
        src: ICON_APP_IOS
      }, React.createElement(FormattedMessage, {
        id: "app-download-icons.download-link",
        defaultMessage: "Download ClassPass for iPhone"
      })))), React.createElement("li", null, React.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: URL_APP_ANDROID,
        onClick: handleClick && handleClick.bind(null, ANDROID)
      }, React.createElement(Isvg, {
        className: "svg",
        uniquifyIDs: false,
        src: ICON_APP_ANDROID
      }, React.createElement(FormattedMessage, {
        id: "app-download-icons.download-link-android",
        defaultMessage: "Download ClassPass for Android"
      })))));
    }
  }]);

  return AppDownloadIcons;
}(PureComponent);
AppDownloadIcons.propTypes = {
  extraClass: PropTypes.string,
  onClick: PropTypes.func
};